
import finImg from '../assets/portfolio/financedata/fin.png'
import nikeImg from '../assets/portfolio/nike/nike.png'
import skindocImg from '../assets/portfolio/skindoc/skindoc.png'
import seifunImg from '../assets/portfolio/seifun/seifun.jpeg'
import sih from '../assets/portfolio/sih-bus/sih.png'
import tailUi from '../assets/portfolio/tailwindUI/tailwindui.png'

export const data = [
	{
		id: 1,
		name: 'SEIFUN.xyz',
		image: seifunImg,
		github: 'https://github.com/lourduradjou/SeiFun',
		live: 'https://www.seifun.xyz',
	},
	{
		id: 2,
		name: 'Nike Store UI',
		image: nikeImg,
		github: 'https://github.com/lourduradjou/Nike-sneaker-showcase',
		live: 'https://lourduradjou.github.io/Nike-sneaker-showcase/',
	},
	{
		id: 3,
		name: 'ManageMate-Connect-Tailwind UI',
		image: tailUi,
		github: 'https://github.com/lourduradjou/ManageMate-Connect-Tailwind-Powered-Collaboration-Hub',
		live: 'https://lourduradjou.github.io/ManageMate-Connect-Tailwind-Powered-Collaboration-Hub/',
	},
	{
		id: 4,
		name: 'Finance Website UI',
		image: finImg,
		github: 'https://github.com/lourduradjou/finance-data-website-frontend-react',
		live: 'https://lourduradjou.github.io/finance-data-website-frontend-react/',
	},
	{
		id: 5,
		name: 'SkinDoc Ai',
		image: skindocImg,
		github: 'https://github.com/lourduradjou/SkinDocAi-IFET-GenAI-Hackathon',
	},
	{
		id: 6,
		name: 'Bus Scheduling NTC Delhi',
		image: sih,
		github: 'https://github.com/lourduradjou/Bus-Scheduling-Smart-India-Hackathon-',
	},
]
